<template>
  <v-row class="navbar" no-gutters>
    <v-col class="centered">
      <div class="name" @click="rotateName">Mathias R. Schneider</div>
    </v-col>
    <v-col v-if="!isMobile" class="nav-bar">
      <a 
        v-for="(section, index) in sections"
        :key="index"
        :href="'#' + section"
        @click.prevent="updateCurrentSection(index)"
        :class="{ active: currentSection === index }"
      >
        {{ section.toUpperCase() }}
      </a>
      <a
        href="/resume.pdf"
        target="_blank"
        rel="noopener"
        class="resume-button"
      >
        RESUME
        <v-icon class="contact-icon ml-1">mdi-open-in-new</v-icon>
      </a> 
    </v-col>
    <v-col v-else cols="6" class="nav-bar">
      <a class="fallback-button" @click="toggleMenu">MENU</a>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Header",
  props: {
    updateCurrentSection: { type: Function, required: true },
    currentSection: { types: Number, default: 0 }
  },
  data() {
    return {
      sections: ["about", "skills", "work", "projects", "contact"],
      isMobile: false,
      menuOpen: false,
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    this.logDimensions();
    window.addEventListener('resize', this.logDimensions);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
    window.removeEventListener('resize', this.logDimensions);
  },
  methods: {
    rotateName() {
      const nameElement = document.querySelector('.name');
      const randomRotation = Math.random() < 0.5
        ? Math.floor(Math.random() * (15 - 10 + 1) + 10) // 10 to 15 degrees
        : Math.floor(Math.random() * (-10 - -15 + 1) + -15); // -15 to -10 degrees
      nameElement.style.transform = `scaleX(1.2) rotate(${randomRotation}deg)`;
      setTimeout(() => {
        nameElement.style.transition = "transform 0.3s ease-out";
        nameElement.style.transform = "scaleX(1.2) rotate(0deg)";
      }, 100);
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    },
    selectSection(index) {
      this.updateCurrentSection(index);
      this.menuOpen = false;
    },
    logDimensions() {
    // Get window width
    const totalWidth = window.innerWidth;

    // Get the "About" button element
    // assuming it's the first section in your `sections` array
    const aboutEl = this.$el.querySelector('a[href="#about"]');

    let aboutOffset = null;
    if (aboutEl) {
      aboutOffset = aboutEl.getBoundingClientRect().left;
    }

    console.log(`Window width: ${totalWidth}px`);
    console.log(`"About" button offset from left: ${aboutOffset}px`);
  }
  }
};
</script>

<style>
@import "~@mdi/font/css/materialdesignicons.css";
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');

.navbar {
  background: linear-gradient(to right, #032855, #023e7b, #032855);
  display: flex;
  align-items: center;
  width: 100vw;
  height: 8.5vh;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  margin: 0;
  padding: 0;
}

.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.nav-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 1rem;
  gap: 0.6rem;
}

.nav-bar a {
  color: #01295a;
  padding: 12px 18px;
  font-size: calc(6vh * 0.3333);
  font-weight: 600;
  background-color: #ffffff;
  border-radius: 8px;
  border: 3px solid #ddaf52;
  text-decoration: none;
  font-family: "Poppins", sans-serif;
  user-select: none;
  height: 6vh;
  transition: all 0.3s ease;
  text-align: center;
  display: flex; /* Enables Flexbox inside the button */
  align-items: center; /* Vertically centers content */
  justify-content: center; /* Horizontally centers text */
}

.nav-bar a:hover {
  color: #ffffff;
  background-color: #01295a;
  transform: scale(1.05);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
}

.nav-bar a:last-child {
  margin-right: 0.6em; /* Twice the gap spacing */
}

.name {
  font-family: 'Schneider', sans-serif;
  font-size: 6.5vh;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  letter-spacing: 3px;
  transform: scaleX(1.2);
  text-shadow: 3px 8px 6px #03234f;
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
}

.name.rotating {
  animation: rotateEffect 0.2s ease-in-out; /* Smooth animation */
}

</style>